import { PDFViewer } from "@react-pdf/renderer";
import { Button, Col, Row } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from "react";
// import { PaymentVoucherPdf } from "./PVPDF";
import { useParams, useNavigate } from "react-router-dom";
import { apiURL, fetchApi, postApi } from "../../../redux/api"; // Ensure this supports FormData
import { Routes } from "../../../routes";
import SupportingDocumentsPv from "./SupportingDocuments";
import NewSupportingDocumentsPv from "./NewSupportducument";
import { PaymentVoucherPdf } from "./PVPDFNew";
import BackButton from "../../../components/BackButton";

const InspectionViewpv = () => {
  const { pv_code } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [pvList, setPvList] = useState([]);
  const [taxesApplied, setTaxesApplied] = useState([]);

 useEffect(() => {
     if (pv_code) {
       setLoading(true);
       fetchApi(`get_new_pv_by_mda?query_type=get_upload_st_pv&id=${pv_code}`)
         .then((data) => {
           setPvList(data.result || []);
         })
         .catch((error) => {
           console.error("Error fetching data:", error);
         })
         .finally(() => {
           setLoading(false);
         });
     }
   }, [pv_code]);

   useEffect(() => {
       if (pvList?.length && pvList[0]?.pv_code) {
         setLoading(true);
         fetchApi(`getTaxesAppliedByPv?pv_code=${pvList[0].pv_code}`)
           .then((data) => {
             setTaxesApplied(data?.data || []);
           })
           .catch((error) => {
             console.error("Error fetching taxes applied:", error);
           })
           .finally(() => setLoading(false));
       }
     }, [pvList]);

  // Handle missing `id` case early
  if (!pv_code) {
    return <p>Error: Missing MDA Code</p>;
  }

    const handleSubmit = () => {
      setLoading(true);
      postApi("update_status/by/pv_code", { status: "Approved PV", pv_code: pvList[0].pv_code })
        .then((response) => {
          console.log("Form submitted successfully:", response);
          navigate(Routes.pv.inspectionPvCheckIndex);
        })
        .catch((error) => {
          console.error("Form submission failed:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    };

  return (
    <div>
      <BackButton />
      <Row>
        <Col md={9}>
          <h4>View Signed PV PDF</h4>
        </Col>
        <Col md={3}>
          <Button
            variant="success"
            className="mt-3"
            // disabled={loading || !file}
            onClick={handleSubmit}
          >
            {loading ? "Processing..." : "Approve PV"}
          </Button>
        </Col>
        <Col md={8}>
          <PDFViewer
            style={{
              width: "100%",
              height: 1000,
            }}
          >
            <PaymentVoucherPdf form={pvList} taxesApplied={taxesApplied}/>
          </PDFViewer>
        </Col>
        <Col md={3}>
          <NewSupportingDocumentsPv pvInfo={pvList} />
          {/* pvInfo={pvInfo} */}
        </Col>
      </Row>
    </div>
  );
};

export default InspectionViewpv;
